// probably obsolete

import { compact } from "./functions"
import Log from "./logging"

const log = new Log ()
log.silent = false
log.name = "Prototype"

function Path(...args) {
    args = compact (args)
    args.__proto__ = Path.prototype
    return args
}

Path.prototype = new Array ()
Path.prototype.last = function() {
    return this[this.length - 1]
}

Path.prototype.url = function(params) {
    let host = ""
    let path = this.slice ()
    if (this[0].match (/^http:|https:|ws:/)) {
        host = this[0]
        path = this.slice (1)
    }
    let url = path.join ("/")
    if (url.length > 1) {
        if (!url.match (/^\//)) {
            if (!url.match (/^http:|https:|ws:/)) {
                url = "/" + url
            }
        }
    }
    url = url.replace (/\/\//g, "/")
    url = `${host}${url}`
    if (params) {
        let args = Object.entries (([key, value]) => `${key}=${value}`).join ("&")
        url += `?${args}`
    }
    return url
}

export default Path
